/** Base path for all service request API endpoints. */
const SERVICE_REQUEST_BASE_PATH =
  'loopay-service-request-management/service-requests';

/**
 * API endpoint paths for the service request management domain.
 *
 * @example
 * serviceRequestEndpoints.SERVICE_REQUESTS
 * // 'loopay-service-request-management/service-requests'
 *
 * serviceRequestEndpoints.VIEW_SERVICE_REQUEST('abc-123')
 * // 'loopay-service-request-management/service-requests/abc-123'
 */
const serviceRequestEndpoints = {
  SERVICE_REQUESTS: SERVICE_REQUEST_BASE_PATH,
  VIEW_SERVICE_REQUEST: (id: string) => `${SERVICE_REQUEST_BASE_PATH}/${id}`,
  UPDATE_SERVICE_REQUEST_STATUS: (id: string) =>
    `${SERVICE_REQUEST_BASE_PATH}/${id}/status`,
  ELIGIBLE_TECHNICIANS: (id: string) =>
    `${SERVICE_REQUEST_BASE_PATH}/${id}/eligible-technicians`,
  ASSIGN_TECHNICIAN: (id: string) =>
    `${SERVICE_REQUEST_BASE_PATH}/${id}/assign`,
  RESCHEDULE_SERVICE_REQUEST: (id: string) =>
    `${SERVICE_REQUEST_BASE_PATH}/${id}/reschedule`,
  ACKNOWLEDGE_SERVICE_REQUEST: (id: string) =>
    `${SERVICE_REQUEST_BASE_PATH}/${id}/acknowledge`,
} as const;

export default serviceRequestEndpoints;
